<template>
  <LazyModal :show="showModal" @update-show="showModal = $event">
    <template v-slot:header>
      <h2 class="h2 mb-3">{{ isDutch ? "Inloggen" : "Sign In" }}</h2>
      <p class="mb-0">{{
          isDutch ? "Voer je e-mailadres en wachtwoord in om verder te gaan." : "Please enter your email address and password to continue."
        }}</p>
    </template>
    <template v-slot:body>
      <form @submit.prevent="signIn">
        <div class="input-group position-relative mb-2">
          <div class="input-group-text">
            <i class="fa-solid fa-at"></i>
          </div>
          <input type="email" class="form-control form-control-lg" id="email"
                 :placeholder="isDutch ? 'E-mailadres' : 'Email address'" v-model="credentials.email">
        </div>
        <div class="input-group position-relative">
          <div class="input-group-text">
            <i class="fa-solid fa-lock"></i>
          </div>
          <input type="password" class="form-control form-control-lg" id="password"
                 :placeholder="isDutch ? 'Wachtwoord' : 'Password'" v-model="credentials.password">
        </div>

        <div class="input-group position-relative mt-4 mb-2">
          <input v-if="isReady"
                 type="submit"
                 :disabled="isLoading"
                 @click="signIn"
                 :value="(isDutch ? 'Inloggen' : 'Sign In')"
                 class="btn btn-primary btn-sm fw-bold w-100 text-white">
          <input v-else
                 type="submit"
                 disabled
                 :value="(isDutch ? 'Voer e-mail en wachtwoord in' : 'Enter your email and password')"
                 class="btn btn-primary btn-sm fw-bold w-100 text-white">
        </div>

        <div v-if="isError" class="alert alert-danger mb-1 mt-3" role="alert">
          <p class="mb-0 small" v-if="isDutch">
            Inloggegevens ongeldig. Probeer het nogmaals.
          </p>
          <p class="mb-0 small" v-else>Invalid login credentials. Please try again.</p>
        </div>
      </form>
    </template>
  </LazyModal>
</template>

<script setup lang="ts">
import {useAuthStore} from "~/store/auth";

const authStore = useAuthStore();
const { proxy } = useScriptGoogleAnalytics()

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  }
});

const showModal = ref(props.show);

const emit = defineEmits(['update-show']);

watch(showModal, (newVal) => {
  if (!newVal) {
    emit('update-show', newVal);
  }
});

const isDutch = inject('isDutch');

const credentials = ref({
  email: '',
  password: '',
});

const isLoading = ref(false);

const isReady = computed(() => {
  return credentials.value.email && credentials.value.password
})

const isError = ref(false);

async function signIn() {
  isLoading.value = true;
  try {
    await authStore.login(
        {
          email: credentials.value.email,
          password: credentials.value.password
        }
    )
    await proxy.gtag("event", "login");
    showModal.value = false;
  } catch (e) {
    isError.value = true
  }
  isLoading.value = false;
}

watch(() => props.show, (newVal) => {
  showModal.value = newVal;
});

</script>